import React from 'react'
import PropTypes from 'prop-types'

/**
 * Renders client select (for wizards/training).
 *
 * @param {Object} props
 * @return {*}
 * @constructor
 */
export function ClientSelect2 (props) {
  const { form, clients, label, name, className } = props
  return (
    <div className={className}>
      <label>{label}</label>
      <select
        className={form.getInputClass(name)}
        required={true}
        name={name}
        value={form.getValue(name)}
        onChange={form.onChange}
      >
        <option value=''/>
        {clients.options2.map(m => (
          <option key={m} value={m}>{m}</option>
        ))}
      </select>
      {form.renderErrors(name)}
    </div>
  )
}

/**
 * Component properties.
 *
 * @type {{}}
 */
ClientSelect2.propTypes = {
  form: PropTypes.object.isRequired,
  clients: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired
}
